export const THDIconButtonStyles = {
    root: {
        color: '#121111',
        '&:hover': {
            backgroundColor: 'transparent',
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent',
            },
        },
    },
    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
        '&:hover': {
            backgroundColor: 'transparent',
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent',
            },
        },
    },
    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
        '&:hover': {
            backgroundColor: 'transparent',
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent',
            },
        },
    },
};
